import { createFileRoute, notFound } from '@tanstack/react-router'
import { getStaticPage } from '@/src/lib/static-pages'
import { Markdown } from '@/src/components/Markdown'
import { NotFound } from '@/src/components/NotFound'
import { useTranslation } from '@/src/i18n/client'

export const Route = createFileRoute('/_static/inbound-email-limits')({
  loader: () => {
    const enPage = getStaticPage('inbound-email-limits', 'en')
    const dePage = getStaticPage('inbound-email-limits', 'de')
    
    if (!enPage && !dePage) {
      throw notFound()
    }
    
    return { enPage, dePage }
  },
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.enPage?.title || 'Inbound Email Limits - GearLens' },
      { name: 'description', content: loaderData?.enPage?.description || 'Limits and guidelines for forwarding drawings via email' }
    ],
  }),
  component: InboundEmailLimitsPage,
})

function InboundEmailLimitsPage() {
  const { i18n } = useTranslation()
  const { enPage, dePage } = Route.useLoaderData()
  
  const currentLocale = i18n.language.split('-')[0]
  const page = currentLocale === 'de' ? dePage : enPage
  
  if (!page) {
    return <NotFound />
  }

  return (
    <div className="container mx-auto max-w-7xl py-8">
      <Markdown 
        content={page.content} 
        className="prose prose-gray dark:prose-invert max-w-none"
      />
      {page.lastUpdated && (
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-8">
          Last updated: {page.lastUpdated}
        </p>
      )}
    </div>
  )
}
